/**
 * List Schema of ResponsavelVisualizador
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelVisualizador} from '@/model/resource/ResponsavelVisualizador'

/* TODO: review generated schema */
export class ListResponsavelVisualizadorSchema extends Schema {
  readonly name = 'ListResponsavelVisualizador'

  readonly fieldSet: FieldSet<ResponsavelVisualizador> = {
    idVisualizadorPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    email: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
